import { createContext, useContext } from "react"

const AdminSecretTapContext = createContext<(() => void) | null>(null)

export const AdminSecretTapProvider = ({
  onSecretTap,
  children,
}: {
  onSecretTap: () => void
  children: React.ReactNode
}) => (
  <AdminSecretTapContext.Provider value={onSecretTap}>{children}</AdminSecretTapContext.Provider>
)

export const useAdminSecretTap = () => {
  const onSecretTap = useContext(AdminSecretTapContext)
  return onSecretTap ?? (() => {})
}
